import React, { Fragment } from 'react';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Step {
  title: string;
  description: string;
}
interface WizardFormProps {
  steps: Step[];
  currentStep: number;
  onStepChange: (step: number) => void;
  onSubmit: () => void;
  children: React.ReactNode;
}
export function WizardForm({
  steps,
  currentStep,
  onStepChange,
  onSubmit,
  children
}: WizardFormProps) {
  const progress = (currentStep + 1) / steps.length * 100;
  return <div className="bg-white rounded-lg border border-gray-200" data-id="element-166">
      {/* Step Indicator */}
      <div className="p-6 border-b border-gray-200" data-id="element-167">
        <div className="flex items-center justify-between mb-4" data-id="element-168">
          {steps.map((step, idx) => <Fragment key={idx} data-id="element-169">
              <div className="flex flex-col items-center" data-id="element-170">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold mb-2 ${idx < currentStep ? 'bg-[#1B5E20] text-white' : idx === currentStep ? 'bg-[#1B5E20] text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-171">
                  {idx < currentStep ? <CheckIcon size={20} data-id="element-172" /> : idx + 1}
                </div>
                <div className={`text-xs font-medium ${idx <= currentStep ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-173">
                  {step.title}
                </div>
              </div>
              {idx < steps.length - 1 && <div className={`flex-1 h-0.5 mx-4 ${idx < currentStep ? 'bg-[#1B5E20]' : 'bg-gray-200'}`} data-id="element-174" />}
            </Fragment>)}
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-175">
          <div className="bg-[#1B5E20] h-2 rounded-full transition-all duration-300" style={{
          width: `${progress}%`
        }} data-id="element-176" />
        </div>
      </div>

      {/* Step Content */}
      <div className="p-6" data-id="element-177">
        <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-178">
          {steps[currentStep].title}
        </h2>
        <p className="text-sm text-gray-600 mb-6" data-id="element-179">
          {steps[currentStep].description}
        </p>
        <div data-id="element-180">{children}</div>
      </div>

      {/* Navigation */}
      <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-181">
        <button onClick={() => onStepChange(currentStep - 1)} disabled={currentStep === 0} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-182">
          <ChevronLeftIcon size={16} data-id="element-183" />
          Back
        </button>
        {currentStep === steps.length - 1 ? <button onClick={onSubmit} className="flex items-center gap-2 px-6 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] transition-colors" data-id="element-184">
            Submit
          </button> : <button onClick={() => onStepChange(currentStep + 1)} className="flex items-center gap-2 px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] transition-colors" data-id="element-185">
            Next
            <ChevronRightIcon size={16} data-id="element-186" />
          </button>}
      </div>
    </div>;
}